import InfoOutlined from '@mui/icons-material/InfoOutlined';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const InfoBox = styled.div`
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.gray01};
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
  border-left: 4px solid ${({ theme }) => theme.colors?.primary};
`;

export const InfoIcon = styled(InfoOutlined)`
  color: ${({ theme }) => theme.colors?.primary};
  flex-shrink: 0;
`;

export const NoticeBox = styled.div`
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.gray01};
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
  border-left: 4px solid ${({ theme }) => theme.colors?.warning};
`;

export const NoticeIcon = styled(ScheduleOutlined)`
  color: ${({ theme }) => theme.colors?.warning};
  flex-shrink: 0;
`;

export const InfoCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const InfoTitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
  font-weight: 600;
`;

export const InfoText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.5rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.backgroundColor};
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
  box-shadow: 0 3px 6px ${({ theme }) => theme.colors?.shadow01 ?? theme.colors?.gray02};

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    padding: 1rem;
  }
`;

export const CardTitle = styled.p`
  margin: 0 0 0.5rem;
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
  font-weight: 600;
`;

export const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 2rem;
`;

export const Breakdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1 28rem;
  max-width: 36rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.large}) {
    max-width: 100%;
  }
`;

export const Line = styled.div`
  display: grid;
  grid-template-columns: 1.5rem 1fr auto;
  align-items: baseline;
  gap: 0.5rem;
`;

export const Sign = styled.span`
  color: ${({ theme }) => theme.colors?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
  font-weight: 600;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const Value = styled.span`
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;

export const SubLine = styled.div`
  display: grid;
  grid-template-columns: 1.5rem 1fr auto;
  align-items: baseline;
  gap: 0.5rem;
  padding-left: 1rem;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};

  span:last-child {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
`;

export const TotalPanel = styled.div`
  flex: 1 1 20rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.5rem;
  border-radius: 10px;
  text-align: center;
  background: ${({ theme }) => theme.colors?.gray01};
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
`;

export const TotalLabel = styled.span`
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 700;
  letter-spacing: 0.02em;
`;

export const TotalValue = styled.span`
  color: ${({ theme }) => theme.colors?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs24};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs20};
  }
`;

export const PaymentBand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors?.primary};
  color: ${({ theme }) => theme.colors?.text?.tertiary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 600;
`;
